import React from 'react';
import PropTypes from 'prop-types';

const Header = ({ hasUserStartedSurvey, headerText }) => (
  <>
    <h1 className="text-large padding-top-10px padding-sm-top-20px">
      {hasUserStartedSurvey ? 'Let’s pick up where we left off.' : headerText}
    </h1>
  </>
);

Header.propTypes = {
  hasUserStartedSurvey: PropTypes.bool,
  headerText: PropTypes.string.isRequired,
};

Header.defaultProps = {
  hasUserStartedSurvey: false,
};

export default Header;
